import { render, staticRenderFns } from "./GastroPosizionamentoBibView.vue?vue&type=template&id=c447b1fc"
import script from "./GastroPosizionamentoBibView.vue?vue&type=script&lang=js"
export * from "./GastroPosizionamentoBibView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports